import Carousel from '../components/Carousel';

export const Homepage = () => {
  return (
    <div className='homepage'>
      <h1>React Carousel</h1>
      <Carousel />
    </div>
  );
};
